/**
 * Сервис для работы с аудио файлами
 * Загрузка и удаление треков на сервер
 */

import { getAuthToken } from './authService';
import { getApiUrl } from './apiBase';

const API_URL = getApiUrl();

/**
 * Загрузить аудио файл на сервер
 */
export async function uploadTrack(file: File): Promise<{ 
  filename: string; 
  path: string; 
  artist?: string; 
  title?: string;
}> {
  const formData = new FormData();
  formData.append('track', file);

  const token = getAuthToken();
  const headers: HeadersInit = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_URL}/tracks/upload`, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Failed to upload track');
  }

  return response.json();
}

/**
 * Удалить аудио файл с сервера
 */
export async function deleteTrack(filename: string): Promise<void> {
  const token = getAuthToken();
  const headers: HeadersInit = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_URL}/tracks/${filename}`, {
    method: 'DELETE',
    headers,
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to delete track');
  }
}

